import { render, staticRenderFns } from "./ContactInfor.vue?vue&type=template&id=560d6bee&"
import script from "./ContactInfor.vue?vue&type=script&lang=js&"
export * from "./ContactInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports